module.exports = __webpack_public_path__ + "prev2.b385c52c.png";